module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"p1s8titles":[{"titleS":false,"title":"Get to know some partner universities"}]},"es":{"p1s8titles":[{"titleS":false,"title":"Aquí tienes algunas universidades amigas"}]}}')
  delete Component.options._Ctor
}
